export enum AccessTokenType {
  USERS = 'users',
  FILE = 'file',
  QUIZ_RESULT = 'quiz_result',
  LOGIN = 'login'
}

